import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getOrder } from '../../../../actionCreators/order';
import LinkProvider from '../../../../CommonComponents/LinkProvider/LinkProvider';
import { isExchangeFlowSet } from '../../../../actionCreators/myAccount';
import { getPaymentMethod } from '../../../../actionCreators/checkout';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import {
  setCurrentReturnItem,
  getOrderItemsReturnElgibilty,
} from '../../../../actionCreators/returnExchange';
import CheckoutPaymentContainer from '../../../containers/Checkout/CheckoutPaymentContainer/CheckoutPaymentContainer';
import ReturnProductCard from './ReturnProductCard';

function ReturnPayment(props) {
  const {
    history,
    exchangeFlowSet,
    location,
    paymentMethods,
    orderDetails,
    isExchangeFlowSet,
    getOrder,
    returnConfig,
    returnEligibiliyDetails,
    getOrderItemsReturnElgibilty,
    setCurrentReturnItem,
    getPaymentMethod,
    currentReturnItem,
    match,
    dataLocale: { EXCHANGE_RETURN },
  } = props;
  const returnOrderId = location?.state?.orderId || match?.params?.id;
  const returnItemId = location?.state?.itemId || match?.params?.itemId;
  const refundMethodRequest = sessionStorageHelper.getItem('refundMethod');
  const items =
    orderDetails && orderDetails?.result?.orders && orderDetails?.result?.orders[0]?.items;

  useEffect(() => {
    if (!exchangeFlowSet) {
      isExchangeFlowSet(true);
    }
  }, [exchangeFlowSet]);

  useEffect(() => {
    isExchangeFlowSet(true);
    if (returnOrderId && returnConfig?.enableNewFlow) getOrderItemsReturnElgibilty(returnOrderId);
    getOrder({ orderId: returnOrderId, dontInitSession: true, isMyAcct: true });
    getPaymentMethod(null, true);
    return () => {
      isExchangeFlowSet(false);
    };
  }, []);

  useEffect(() => {
    if (returnItemId && items && items.length) {
      const returnProductItems = items?.filter(item => returnItemId == item.id); // eslint-disable-line
      const currentItemReturnEligibiliyDetails =
        returnEligibiliyDetails?.items?.find(item => item.id == returnItemId) || {}; // eslint-disable-line
      setCurrentReturnItem({
        item: { ...returnProductItems[0], ...currentItemReturnEligibiliyDetails },
      });
    }
  }, [items, returnEligibiliyDetails]);

  useEffect(() => {
    if (returnOrderId && returnConfig?.enableNewFlow && !returnEligibiliyDetails) {
      getOrderItemsReturnElgibilty(returnOrderId);
    }
  }, [returnOrderId]);

  return (
    <>
      <h3 className="margin-l5" style={{ color: '#3C3C3C', fontFamily: 'Roboto' }}>
        <LinkProvider
          className="no-decoration back-cta fw700 font-medium uppercase inline-block cursor-pointer"
          to={`/customer/my/order/return/${returnOrderId}/${returnItemId}`}
        >
          <i aria-hidden="true" className="fa fa-angle-left fw700 fs18 margin-r15 pos-rel"></i>
        </LinkProvider>
        {EXCHANGE_RETURN}
      </h3>
      <div className="margin-t30 display-flex">
        <div className="bora-8" style={{ width: '70vw', marginRight: '5px' }}>
          <CheckoutPaymentContainer
            exchange
            exchangeFlowSet={exchangeFlowSet}
            history={history}
            location={location}
            paymentMethods={paymentMethods}
          />
        </div>
        <div
          className="bora-8 order-box"
          style={{
            width: '30vw',
            height: 'fit-content',
            marginLeft: '5px',
            marginTop: '10px',
            padding: '5px',
          }}
        >
          <ReturnProductCard
            item={currentReturnItem?.item}
            refundMethodRequest={refundMethodRequest}
            top="60%"
          />
        </div>
      </div>
    </>
  );
}

const mapStateToProps = state => {
  return {
    currentReturnItem: state.returnExchange.currentReturnItem,
    orderDetails: state.order.orderDetails,
    returnEligibiliyDetails: state.returnExchange.returnEligibiliyDetails,
    exchangeFlowSet: state.myAccount.exchangeFlowSet,
    paymentMethods: state.checkout.paymentMethods,
    returnConfig: state.myAccount.returnConfig,
    dataLocale: state.locale,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    isExchangeFlowSet: data => dispatch(isExchangeFlowSet(data)),
    getOrder: data => dispatch(getOrder(data)),
    setCurrentReturnItem: data => dispatch(setCurrentReturnItem(data)),
    getOrderItemsReturnElgibilty: data => dispatch(getOrderItemsReturnElgibilty(data)),
    getPaymentMethod: (orderId, isExchange, isSalesman) =>
      dispatch(getPaymentMethod(orderId, isExchange, isSalesman)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnPayment);
